// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__S6Kb-","label":"style_label__9WfD-","btn_icon":"style_btn_icon__D1o1h"};